import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NSlider = _resolveComponent("NSlider")!

  return (_openBlock(), _createBlock(_component_NSlider, _mergeProps(_ctx.$props, {
    class: _ctx.cssClass,
    "onUpdate:modelValue": _ctx.changeHandler
  }), null, 16, ["class", "onUpdate:modelValue"]))
}